const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;

const { InspectorControls } = wp.blockEditor;

const {
	PanelBody,
	SelectControl,
	Disabled,
	ToggleControl
} = wp.components;
const { serverSideRender: ServerSideRender } = wp;

import icons from "../../../icons.js";
/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType("wp-apidae/handicap", {
	title: __("Handicap", "wp-apidae"), // Block title.
	description: __("Affiche les informations sur l'accueil des personnes en situation de handicap.", "wp-apidae"),
	icon: {
		foreground: '#EFB114',
		background: '#331F5B',
		src: icons.handicap
	},
	supports: {
    align: ['full','wide'],
  },
	example: {
  },
	attributes: {
		labelsTourismeHandicap: {
			type: "boolean",
			default: true,
		},
		tourismesAdaptes: {
			type: "boolean",
			default: true,
		},
		descriptifHandicapAuditif: {
			type: "boolean",
			default: true,
		},
		descriptifHandicapMental: {
			type: "boolean",
			default: true,
		},
		descriptifHandicapMoteur: {
			type: "boolean",
			default: true,
		},
		descriptifHandicapVisuel: {
			type: "boolean",
			default: true,
		},
		nombrePersonnesEnFauteuilRoulantAccueilliesSimultanement: {
			type: "boolean",
			default: true,
		},
		show_title: {
			type: "boolean",
			default: true,
		},
		field_tag: {
			type: 'string',
			default: 'h2',
		},
		ss_field_tag: {
			type: 'string',
			default: 'h3',
		},
		align: {
			type: 'string',
			default: '',
		},
	},

	edit: class extends wp.element.Component {
		render() {
			const props = this.props;
			const attributes = props.attributes;

			var template = window.WpApidaeTemplateData.settings;
			const fieldsTags          = window.WpApidaeTemplateData.fieldsTags;

			return [
					<InspectorControls key={"inspector"}>
						<PanelBody title={__("Affichage")}>
						<ToggleControl
								label={ __( 'Labels tourisme handicap' ) }
								checked={ attributes.labelsTourismeHandicap }
								onChange={ () => {
									props.setAttributes({ labelsTourismeHandicap: ! attributes.labelsTourismeHandicap });
								} }
							/>
						<ToggleControl
								label={ __( 'Tourisme adaptés' ) }
								checked={ attributes.tourismesAdaptes }
								onChange={ () => {
									props.setAttributes({ tourismesAdaptes: ! attributes.tourismesAdaptes });
								} }
							/>
							<ToggleControl
								label={ __( 'Handicap auditif' ) }
								checked={ attributes.descriptifHandicapAuditif }
								onChange={ () => {
									props.setAttributes({ descriptifHandicapAuditif: ! attributes.descriptifHandicapAuditif });
								} }
							/>
							<ToggleControl
								label={ __( 'Handicap mental' ) }
								checked={ attributes.descriptifHandicapMental }
								onChange={ () => {
									props.setAttributes({ descriptifHandicapMental: ! attributes.descriptifHandicapMental });
								} }
							/>
							<ToggleControl
								label={ __( 'Handicap moteur' ) }
								checked={ attributes.descriptifHandicapMoteur }
								onChange={ () => {
									props.setAttributes({ descriptifHandicapMoteur: ! attributes.descriptifHandicapMoteur });
								} }
							/>
							<ToggleControl
								label={ __( 'Handicap visuel' ) }
								checked={ attributes.descriptifHandicapVisuel }
								onChange={ () => {
									props.setAttributes({ descriptifHandicapVisuel: ! attributes.descriptifHandicapVisuel });
								} }
							/>
							<ToggleControl
								label={ __( 'Fauteuil roulant simultané' ) }
								checked={ attributes.nombrePersonnesEnFauteuilRoulantAccueilliesSimultanement }
								onChange={ () => {
									props.setAttributes({ nombrePersonnesEnFauteuilRoulantAccueilliesSimultanement: ! attributes.nombrePersonnesEnFauteuilRoulantAccueilliesSimultanement });
								} }
							/>
						</PanelBody>
						<PanelBody title={__("Options")}>
						<ToggleControl
								label={ __( 'Afficher un titre de section' ) }
								checked={ attributes.show_title }
								onChange={ () => {
									props.setAttributes({ show_title: ! attributes.show_title });
								} }
							/>
							{ true === attributes.show_title &&
							<SelectControl
							label={ __( 'Balise à utiliser' ) }
							value={ attributes.field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									field_tag: newValue,
								});
							}}
						/>}
						<SelectControl
							label={ __( 'Balise des sous titres' ) }
							value={ attributes.ss_field_tag }
							options={fieldsTags}
							onChange={ newValue => {
								props.setAttributes({
									ss_field_tag: newValue,
								});
							}}
						/>
						</PanelBody>
					</InspectorControls>,
						<Disabled>
						<ServerSideRender
							block="wp-apidae/handicap"
							attributes={attributes}
							urlQueryArgs={{
							settings:template
						}}/>
					</Disabled>
				,
			];
		}
	},

	save: () => {
		return null;
	},
});
